export default {
  fp: 'f09a0d0647bb25c68a727725927471fe',
  consent: {
    client: {
      client_id: null,
      client_name: null,
      client_uri: null,
      logo_uri: null,
      tos_uri: null,
      policy_uri: null
    },
    user: {
      userId: null,
      username: null,
      tel: null,
      email: null,
      avatar: null
    },
    requestedScope: []
  },
  consentChallenge: null,
  loginChallenge: null
}
